import Navbar from "../components/Navbar";
import Footer from "../Footer";
import "./PolicyPages.css";

const responsibilities = [
  {
    number: "01",
    title: "Build Awareness",
    description:
      "Introduce relevant CODEION programs, learning initiatives, workshops, and opportunities to students in your college community.",
  },
  {
    number: "02",
    title: "Student Outreach",
    description:
      "Connect with student communities, clubs, societies, and learners who may benefit from CODEION programs and events.",
  },
  {
    number: "03",
    title: "Promote Initiatives",
    description:
      "Share approved CODEION content and campaigns through appropriate college and social communication channels.",
  },
  {
    number: "04",
    title: "Share Feedback",
    description:
      "Help CODEION better understand student interests, learning needs, questions, and feedback from your campus community.",
  },
];

const benefits = [
  "Gain practical experience in communication, outreach, and community building",
  "Develop leadership and professional networking skills",
  "Work with a growing education-focused technology initiative",
  "Receive recognition based on participation and program criteria",
  "Access selected learning, networking, or growth opportunities where offered",
  "Build experience that can strengthen your professional profile",
];

const process = [
  {
    number: "01",
    title: "Submit Application",
    description:
      "Share your contact details, college information, profile, and why you want to represent CODEION.",
  },
  {
    number: "02",
    title: "Application Review",
    description:
      "The CODEION team reviews applications based on communication, motivation, campus involvement, and current requirements.",
  },
  {
    number: "03",
    title: "Shortlisting",
    description:
      "Shortlisted applicants may be contacted for a discussion or additional information.",
  },
  {
    number: "04",
    title: "Start Your Journey",
    description:
      "Selected ambassadors receive information about responsibilities, guidelines, activities, and applicable program terms.",
  },
];

function CampusAmbassador() {
  return (
    <div className="opportunity-page">
      <Navbar />

      <main className="opportunity-main">
        <div className="opportunity-wrapper">
          <section className="opportunity-hero">
            <div className="opportunity-hero-content">
              <span className="legal-eyebrow">
                CODEION CAMPUS OPPORTUNITIES
              </span>

              <h1>
                Become a Campus <span>Ambassador</span>
              </h1>

              <p>
                Represent CODEION in your college community, strengthen your
                communication and leadership skills, build your network, and
                contribute to practical technology learning initiatives.
              </p>

              <div className="opportunity-hero-actions">
                <a
                  className="support-primary-button"
                  href="mailto:careers@codeion.in?subject=CODEION%20Campus%20Ambassador%20Application"
                >
                  Apply Now →
                </a>

                <a
                  className="support-secondary-button"
                  href="#career-opportunity"
                >
                  View Opportunity ↓
                </a>
              </div>

              <div className="opportunity-hero-note">
                <span>✓</span>
                Openings and selection depend on current CODEION program and
                campus requirements.
              </div>
            </div>

            <div className="opportunity-highlight-card">
              <span className="opportunity-highlight-label">
                CAMPUS AMBASSADOR
              </span>

              <h2>Represent, connect, communicate, and grow.</h2>

              <div className="opportunity-highlight-list">
                <div>
                  <strong>Build Leadership</strong>
                  <span>Develop communication and ownership skills</span>
                </div>

                <div>
                  <strong>Grow Your Network</strong>
                  <span>Connect with students and professionals</span>
                </div>

                <div>
                  <strong>Gain Experience</strong>
                  <span>Work on real outreach and community activities</span>
                </div>
              </div>
            </div>
          </section>

          <section id="career-opportunity" className="opportunity-section">
            <div className="support-section-heading">
              <span>YOUR ROLE</span>

              <h2>What you'll do as a Campus Ambassador</h2>

              <p>
                Help CODEION connect with learners while building practical
                communication, outreach, and community experience.
              </p>
            </div>

            <div className="opportunity-card-grid">
              {responsibilities.map((item) => (
                <article className="opportunity-card" key={item.title}>
                  <div className="opportunity-card-number">
                    {item.number}
                  </div>

                  <h3>{item.title}</h3>

                  <p>{item.description}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="opportunity-split-section">
            <div className="opportunity-info-panel">
              <span className="legal-eyebrow">WHO CAN APPLY?</span>

              <h2>Students who want to lead, connect, and learn.</h2>

              <p>
                The Campus Ambassador opportunity may be suitable for currently
                enrolled college students who are active, responsible, and
                interested in technology, education, communication, marketing,
                student communities, or professional development.
              </p>

              <ul className="opportunity-check-list">
                <li>
                  <span>✓</span>
                  Currently enrolled college students
                </li>

                <li>
                  <span>✓</span>
                  Good communication and interpersonal skills
                </li>

                <li>
                  <span>✓</span>
                  Interest in technology and education
                </li>

                <li>
                  <span>✓</span>
                  Ability to communicate responsibly with student communities
                </li>

                <li>
                  <span>✓</span>
                  Willingness to follow CODEION communication and branding
                  guidelines
                </li>
              </ul>
            </div>

            <aside className="opportunity-side-card">
              <span className="opportunity-highlight-label">
                WHAT YOU CAN GAIN
              </span>

              <h3>Build experience beyond the classroom</h3>

              <ul className="opportunity-benefit-list">
                {benefits.map((benefit) => (
                  <li key={benefit}>{benefit}</li>
                ))}
              </ul>

              <div className="legal-notice">
                Rewards, certificates, incentives, learning benefits, or other
                opportunities are subject to the terms communicated for the
                applicable Campus Ambassador program.
              </div>
            </aside>
          </section>

          <section className="opportunity-section">
            <div className="support-section-heading">
              <span>APPLICATION PROCESS</span>

              <h2>How to become a Campus Ambassador</h2>

              <p>
                Apply, complete the review process, and start contributing if
                selected for an available opportunity.
              </p>
            </div>

            <div className="opportunity-process">
              {process.map((step) => (
                <article className="opportunity-process-card" key={step.title}>
                  <span>{step.number}</span>

                  <h3>{step.title}</h3>

                  <p>{step.description}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="opportunity-cta">
            <div>
              <span className="legal-eyebrow">START YOUR JOURNEY</span>

              <h2>Ready to represent CODEION?</h2>

              <p>
                Send your profile, college details, contact information, and a
                short introduction explaining why you want to become a Campus
                Ambassador.
              </p>
            </div>

            <a
              className="support-primary-button"
              href="mailto:careers@codeion.in?subject=CODEION%20Campus%20Ambassador%20Application"
            >
              Apply Now →
            </a>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default CampusAmbassador;